module.exports = __webpack_public_path__ + "img/gear-D-high_170x170.f1c61bfe.png";